var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/\xED\x99\x88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.34375 25.7812H8.20312V16.0156H16.7969V25.7812H22.6562V10.5469L12.5 2.92969L2.34375 10.5469V25.7812ZM0 28.125V9.375L12.5 0L25 9.375V28.125H14.4531V18.3594H10.5469V28.125H0Z",
    fill: "#002868"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavHome);
export default __webpack_public_path__ + "static/media/nav-home.342dbf2e29045789368fa68f1d8b5da2.svg";
export { ForwardRef as ReactComponent };